module.exports = __webpack_public_path__ + "img/thumbnail_BlackWildebeest_j_normal.148da512.png";